import i18n from "../i18n";

const LANGUAGE_KEY = "app-language";

const languageHelper = {
  /**
   * Get current active language from i18n
   */
  getCurrentLanguage() {
    return i18n.language || "fr";
  },

  /**
   * Change language immediately in i18n and persist to localStorage
   */
  async changeLanguage(lang) {
    const normalized = lang.toLowerCase(); // Handle 'EN' → 'en'
    
    // Update i18n
    await i18n.changeLanguage(normalized);
    
    // Persist to localStorage
    localStorage.setItem(LANGUAGE_KEY, normalized);
  },

  /**
   * Sync to backend PreferredLang - ONLY on initial login
   * Call this once in your auth reducer/thunk, NOT in useEffect
   */
  async syncUserLanguage(user) {
    if (!user?.preferredLang) return;
    await this.changeLanguage(user.preferredLang);
  },

  /**
   * Get flag image for language
   */
  getFlagImage(lang) {
    const flags = {
      en: "/assets/img/flags/us-flag.jpg",
      fr: "/assets/img/flags/fr-flag.jpg",
      es: "/assets/img/flags/es-flag.jpg",
      de: "/assets/img/flags/de-flag.jpg"
    };
    return flags[lang?.toLowerCase()] || flags.fr;
  }
};

export default languageHelper;